import { AppRouteProps } from "@bsm/component";
import { ProjectDayOffCreateRoutes } from "./views/create/ProjectDayOffCreateRoutes";
import { ProjectCalendarCardDetailsRoutes } from "views/calendar/views/details/ProjectCalendarCardDetailsRoutes";
import ProjectDayOffMissingContainer from "./container/ProjectDayOffMissingContainer";
import { DayoffMissingDetailsRoutes } from "./views/details/DayoffMissingDetailsRoutes";

export const ProjectDayOffMissingRoutes: Array<AppRouteProps> = [
    {
        path: "missing",
        title: "BSMRH.Project.DayOff.Management.Vacation.Abscence.Label",
        element: <ProjectDayOffMissingContainer />,
        children: [
            ...DayoffMissingDetailsRoutes,
            ...ProjectDayOffCreateRoutes
        ]
    },
];
